import React from 'react';
import PropTypes from 'prop-types';
import BoolAttr from './attrTypes/BoolAttr';
import TextAttr from './attrTypes/TextAttr';
import FeaturesAttr from './attrTypes/FeaturesAttr';
import ImageAttr from './attrTypes/ImageAttr';
import RatingAttr from './attrTypes/RatingAttr';
import ProductNameAttr from './attrTypes/ProductNameAttr';

/**
 * Map attribute types to components
*/
const attrTypes = {
  bool: BoolAttr,
  text: TextAttr,
  features: FeaturesAttr,
  image: ImageAttr,
  rating: RatingAttr,
  productName: ProductNameAttr,
};

const ProductAttrCell = function ProductAttrCellComponent({ attrKey, productAttr }) {
  /**
   * Determine which type of attribute component to render each table cell
   *
   * @param { string } attrKey - A key used to identify each attribute
   * @param { Object } productAttr - An attribute with a label, type, and value
   * @return { Array } - A table-friendly representation of product comparisons
  */
  const getAttrType = function getAttrTypeFunc(attrKey, productAttr) {
    if (attrKey === 'image') {
      return 'image';
    }

    if (attrKey === 'rating') {
      return 'rating';
    }

    if (attrKey === 'name') {
      return 'productName';
    }

    let type = 'text';

    if (['Yes', 'No'].indexOf(productAttr.value) > -1) {
      type = 'bool';
    }

    if (productAttr.label === 'Features') {
      type = 'features';
    }

    return type;
  };

  const type = getAttrType(attrKey, productAttr);
  const Component = attrTypes[type] || attrTypes.text;

  return (<Component value={productAttr.value} />);
};

ProductAttrCell.propTypes = {
  attrKey: PropTypes.string.isRequired,
  productAttr: PropTypes.shape({
    label: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.oneOfType([
      PropTypes.shape({}),
      PropTypes.string,
    ]),
  }).isRequired,
};

export default ProductAttrCell;
